import { Box, useTheme } from "@mui/material"
import BaseCard from "../../../theme/cards/BaseCard"
import { tokens } from "../../../../theme";
import Text from "../../../theme/text/Text";
import CardLabel from "../../../theme/label/CardLabel";
import TopRight from "../../../theme/positionals/TopRight";
import { useTranslation } from "react-i18next";
import ShDoubleTextSkeleton from "../../../theme/skeleton/ShDoubleTextSkeleton";
import Icon from "../../../theme/icons/Icon";
import { PrintDisabledRounded, PrintRounded } from "@mui/icons-material";
import { GridCheckIcon, GridCloseIcon } from "@mui/x-data-grid";
import ShTextSkeleton from "../../../theme/skeleton/ShTextSkeleton";
import { useState } from "react";
import PopoverModal from "../../../theme/Modal/PopoverModal";

export const PrinterCard = (props) => {
    const { t,i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [anchorEl, setAnchorEl] = useState(null);
    const popoverOpen = Boolean(anchorEl);
    const popoverId = popoverOpen ? 'popover' : undefined;
    
    const handlePopoverClick = (event) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <BaseCard sx={{p:1}}  onClick={props.skeleton ? null : props.onClick}>
            <Box>
                <Box
                >
                    <Box
                        sx={{
                            display:"flex",
                            flexDirection:"column",
                            pl:1,
                            pt:1,
                        }}
                    >
                        {props.skeleton ? 
                            <ShDoubleTextSkeleton/> 
                            :
                            <>
                                <Text bold>{props.description}</Text>
                                <Text light>{props.internal_name}</Text>
                            </>
                        }
                    </Box>
                    <TopRight>

                        <CardLabel 
                            fitted
                            variant={ theme.palette.mode === "dark" ? "greyLight" : "grey"}  
                            position="child-tr"
                            hasright
                        >
                            {props.skeleton ? 
                                <ShDoubleTextSkeleton/> 
                                :
                                props.format
                            }
                        </CardLabel>


                        <CardLabel 
                            onClick={handlePopoverClick}
                            variant={props.skeleton ? theme.palette.mode === "dark" ? "greyLight" : "grey" : props.zpl_support ? "green" : "red"}  
                            position="child-tr"
                            hasleft
                            colorflip
                            icon
                        >
                            {props.skeleton ? 
                                <ShDoubleTextSkeleton/> 
                                :
                                <>
                                    {props.zpl_support ? (
                                        <GridCheckIcon 
                                            fontSize="small" 
                                            sx={{
                                                color: theme.palette.mode === "dark" ? colors.txt["primaryDark"] : colors.txt["light"]
                                            }} 
                                        />
                                    ) : (
                                        <GridCloseIcon 
                                            fontSize="small" 
                                            sx={{
                                                color: theme.palette.mode === "dark" ? colors.txt["primaryDark"] : colors.txt["light"]
                                            }} 
                                        />
                                    )}
                                </>
                            }
                        </CardLabel>
                    </TopRight>

                    <Box 
                        sx={{
                            mt:2,
                            display:"flex",
                            justifyContent:"flex-start",
                            gap:3,
                            borderRadius:2,
                            overflow:"hidden",
                            background:colors.grey[50],
                            p:1,
                        }}
                    >

                        <Box
                            sx={{
                                minWidth:110,
                                display:"flex",
                                flexDirection:"column",
                                gap:1,
                            }}
                        >
                            <Text light>{t("warehouse")}</Text>
                            <Text light>{t("custom_width")}</Text>
                            <Text light>{t("custom_height")}</Text>
                        </Box>
                        <Box
                            sx={{
                                minWidth:110,
                                display:"flex",
                                flexDirection:"column",
                                gap:1,
                            }}
                        >
                            <Text noBreak>{props.warehouse?.name}</Text>
                            <Text noBreak>{props.custom_width}</Text>
                            <Text noBreak>{props.custom_height}</Text>
                        </Box>
                       
                    </Box>
                    
                </Box>
                <IMPrinterZPL 
                    zpl_support={props.zpl_support}
                    id={popoverId}
                    open={popoverOpen}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    stopPropagation={true}
                />
            </Box>
        </BaseCard>
    )
}


const IMPrinterZPL = (props) => {
    const {t} = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    let isStandAlone = false;
    if (window.matchMedia('(display-mode: standalone)').matches) {
        isStandAlone = true;
    }

    return (
        
        <PopoverModal
            {...props}
            triangle={{position:"center",color:theme.palette.mode === "dark" ? colors.grey[300] : "#fff"}}
        >
            <Box 
                sx={{
                    background: theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                    padding:3,
                    paddingBottom: isStandAlone ? 4 : 3,
                    borderRadius:"16px",
                    borderBottomLeftRadius:0,
                    borderBottomRightRadius:0,
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"center",
                    "@media screen and (max-width: 48em)" : {
                        borderRadius:"32px",
                        borderTopLeftRadius:"12px",
                        borderTopRightRadius:"12px",
                        borderBottomLeftRadius:0,
                        borderBottomRightRadius:0,

                    }
                }}
            >
                {props.zpl_support ?
                    <Box
                        sx={{
                            display:"flex",
                            alignItems:"center",
                            justifyContent:"center",
                            flexDirection:"column",
                            gap:1,
                        }}
                    >
                        <Box
                            sx={{
                                width:40,
                                height:40,
                                borderRadius:3,
                                background:colors.green[100],
                                display:"flex",
                                alignItems:"center",
                                justifyContent:"center"
                            }}
                        >
                            <GridCheckIcon  sx={{color:colors.green[400]}}/> 
                        </Box>
                        <Text semibold>{t('zpl_support')}</Text>
                    </Box>
                :
                    <Box
                        sx={{
                            display:"flex",
                            alignItems:"center",
                            justifyContent:"center",
                            flexDirection:"column",
                            gap:1,
                        }}
                    >
                        <Box
                            sx={{
                                width:40,
                                height:40,
                                borderRadius:3,
                                background:colors.red[100],
                                display:"flex",
                                alignItems:"center",
                                justifyContent:"center"
                            }}
                        >
                            <GridCloseIcon  sx={{color:colors.red[400]}}/> 
                        </Box>
                        <Text semibold>{t('zpl_support')}</Text>
                    </Box>
                }

                
            </Box>

        </PopoverModal>
    );
}